export const REDIRECT_NAME = 'Redirect'

export const PARENT_LAYOUT_NAME = 'ParentLayout'

export const PAGE_NOT_FOUND_NAME = 'PageNotFound'

/** 空白 */
export const BLANK_LAYOUT = () => import('@/layouts/BlankLayout.vue')

/** 主页面布局 */
export const PAGE_LAYOUT = () => import('@/layouts/PageLayout.vue')

/**
 * 首页布局
 * 左中右
 * 左 leftSide
 * 中 content
 * 右 rightSide
*/
export const INDEX_LAYOUT = () => import('@/components/layouts/IndexLayout.vue')

/** 和上面的区别就是 content 带导航 */
export const INDEX_NAV_LAYOUT = () => import('@/components/layouts/IndexNavLayout.vue')

/** 搜索 */
export const INDEX_SEARCH_LAYOUT = () => import('@/components/layouts/IndexSearchLayout.vue')

export const EXCEPTION_COMPONENT = () => import('@/views/sys/exception/404.vue')

export const BUILDING_PAGE = () => import('@/views/sys/exception/building.vue')
export const LOGIN_OUT = () => import('@/views/sys/exception/loginOut.vue')

